import { X } from "lucide-react";
import { useEffect } from "react";
import { ImagePost } from "../../types";
import "./chat-image-gallery.css";

interface ChatImageGalleryProps {
    open: boolean;
    images: ImagePost[];
    onClose: () => void;
}

/**
 * Gallery used by the overflow tile in a chat message.
 * Unlike the regular image viewer, it keeps every attachment in one vertical list.
 */
export default function ChatImageGallery({ open, images, onClose }: ChatImageGalleryProps) {
    useEffect(() => {
        if (!open) return;

        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === "Escape") onClose();
        };

        document.body.style.overflow = "hidden";
        document.addEventListener("keydown", handleKeyDown);

        return () => {
            document.body.style.overflow = "";
            document.removeEventListener("keydown", handleKeyDown);
        };
    }, [open, onClose]);

    if (!open) return null;

    return (
        <div className="chat-image-gallery" role="dialog" aria-modal="true" aria-label="Galeria de imagens" onClick={onClose}>
            <div className="chat-image-gallery__content" onClick={event => event.stopPropagation()}>
                <button className="chat-image-gallery__close" type="button" onClick={onClose} aria-label="Fechar galeria">
                    <X size={24} />
                </button>
                <div className="chat-image-gallery__list">
                    {images.map((image, index) => (
                        <img
                            key={`${image.path}-${index}`}
                            src={image.path}
                            alt={`Imagem ${index + 1}`}
                            className="chat-image-gallery__image"
                            draggable={false}
                            onError={event => {
                                event.currentTarget.src = "/img/image_not_found.png?v=1";
                            }}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}
